import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

/** Sections of the one-page landing, in page order. */
export const SECTIONS = ['growth', 'acceleration'];

/** The team lives on the Draper Dragon site. */
export const TEAM_URL = 'https://www.draperdragon.com/#team';

/**
 * Link to a section of the one-page landing (/#id).
 * On the landing page it smooth-scrolls in place (and works when clicked twice);
 * from any other page it navigates to / and the landing scrolls to the section.
 */
export default function AnchorLink({ id, onClick, children, ...rest }) {
  const location = useLocation();
  const handleClick = (e) => {
    onClick?.(e);
    if (location.pathname !== '/') return;
    const el = document.getElementById(id);
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    window.history.replaceState(window.history.state, '', `/#${id}`);
  };
  return (
    <Link to={`/#${id}`} onClick={handleClick} {...rest}>
      {children}
    </Link>
  );
}

/** Which landing section is currently in view (for nav highlighting). */
export function useActiveSection(enabled) {
  const [active, setActive] = useState(null);
  useEffect(() => {
    if (!enabled || !('IntersectionObserver' in window)) {
      setActive(null);
      return undefined;
    }
    const els = SECTIONS.map((id) => document.getElementById(id)).filter(Boolean);
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
          else setActive((cur) => (cur === e.target.id ? null : cur));
        });
      },
      { rootMargin: '-45% 0px -50% 0px' }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [enabled]);
  return active;
}
